import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "mainSlice",
  initialState: {
    isDisplayHeader: true,
    isDisplayFooter: false,
    isCustomHeader: false,
    isCustomFooter: false,
    isSidebarOpened: false,
    isLoad: false,
    customHeaderText: "",
  },
  reducers: {
    headerDisplaying: (state, action) => {
      state.isDisplayHeader = action.payload;
    },
    footerDisplaying: (state, action) => {
      state.isDisplayFooter = action.payload;
    },
    headerCustomDisplaying: (state, action) => {
      state.isCustomHeader = action.payload;
    },
    setSidebarOpened: (state, action) => {
      state.isSidebarOpened = action.payload;
    },
    setCustomHeaderText: (state, action) => {
      state.customHeaderText = action.payload;
    },
    footerCustomDisplaying: (state, action) => {
      state.isDisplayFooter = action.payload;
      state.isCustomFooter = action.payload;
    },
    isLoadChanger: (state, action) => {
      state.isLoad = action.payload;
    },
  },
});

export const {
  headerDisplaying,
  footerDisplaying,
  setSidebarOpened,
  headerCustomDisplaying,
  footerCustomDisplaying,
  setCustomHeaderText,
  isLoadChanger,
} = slice.actions;

export default slice.reducer;
